import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {Device} from 'src/app/infrastructure/moovement-api/models/asset';

export enum OnboardingAction {
  associateToExistingAsset = "associateToExistingAsset",
  createNewAsset = "createNewAsset"
}

interface AddProximitySamplePointState {
  name: string | undefined,
  lat: number | undefined,
  long: number | undefined,
  deviceToMatch: Device | undefined,
  id: string | undefined,
  hardwareId: boolean,
  sampleBasedLocation: boolean,
  onboardingAction: OnboardingAction | undefined
}

const initialState: AddProximitySamplePointState = {
  name: undefined,
  lat: undefined,
  long: undefined,
  deviceToMatch: undefined,
  id: undefined,
  hardwareId: false,
  sampleBasedLocation: false,
  onboardingAction: undefined
};

export const AddProximitySamplePointStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setName(name?: string) {
      patchState(store, {name});
    },
    setLat(lat?: number) {
      patchState(store, {lat});
    },
    setLong(long?: number) {
      patchState(store, {long});
    },
    setDeviceToMatch(deviceToMatch?: Device) {
      patchState(store, {deviceToMatch});
    },
    setId(id?: string) {
      patchState(store, {id});
    },
    setHardwareId(hardwareId: boolean) {
      patchState(store, {hardwareId});
    },
    setOnboardingAction(onboardingAction?: OnboardingAction) {
      patchState(store, {onboardingAction})
    },
    setSampleBasedLocation(sampleBasedLocation: boolean) {
      patchState(store, {sampleBasedLocation});
    },
    reset() {
      patchState(store, initialState);
    }
  })
));
